import { render, staticRenderFns } from "./ConfigCharts.vue?vue&type=template&id=72a95499&scoped=true&"
import script from "./ConfigCharts.vue?vue&type=script&lang=js&"
export * from "./ConfigCharts.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCharts.vue?vue&type=style&index=0&id=72a95499&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a95499",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsItems } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VCard,VCol,VPagination,VRow,VSelect,VTab,VTabItem,VTabs,VTabsItems,VTextField,VToolbar})
